/* eslint-disable react-native/no-inline-styles */
/* eslint-disable prettier/prettier */
import React from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import { scale as initialScale, scaleWeb } from '@components/frame';
import TouchableElement from '@components/common/touchableElement';
import ColorWrapper from '@styles/colors';
import { font as initialFont } from '@styles/fonts';

const Button = (props) => {
  const {
    C,
    variant = 'L',
    type = 'Primary',
    disabled = false,
    background,
    onPress,
    onPressIn,
    loading,
    colors,
    minWidth,
    borderRadius: customBorderRadius = false,
    customStyle,
    font = initialFont,
    scale = initialScale,
    testID,
  } = props;
  const s = scale;
  const backgroundResult = background || C.schemeName;
  const {
    textFont,
    paddingLeft,
    paddingRight,
    paddingTop,
    paddingBottom,
    borderRadius,
    sizeConfig = {},
  } = (() => {
    switch (variant) {
      case 'Dialog M':
        return {
          textFont: font.Headline,
          paddingLeft: 25,
          paddingRight: 25,
          paddingTop: 11,
          paddingBottom: 11,
          borderRadius: 3,
        };
      case 'Dialog L':
        return {
          textFont: font.Headline,
          paddingLeft: 25,
          paddingRight: 25,
          paddingTop: 16,
          paddingBottom: 15,
          borderRadius: 3,
        };
      case 'L':
        return {
          textFont: font['Button 1'],
          paddingLeft: 18,
          paddingRight: 18,
          paddingTop: 8.25,
          paddingBottom: 7.75,
          borderRadius: 18,
        };
      case 'M':
        return {
          textFont: font['Button 2'],
          paddingLeft: 14,
          paddingRight: 14,
          paddingTop: 7.12,
          paddingBottom: 6.88,
          borderRadius: 14.5,
        };
      case 'S':
        return {
          textFont: font['Button 3'],
          paddingLeft: 13,
          paddingRight: 13,
          paddingTop: 6,
          paddingBottom: 6,
          borderRadius: 13,
        };
      case 'Icon Button':
        return {
          sizeConfig: {
            width: 29,
            height: 29,
            borderRadius: 29 / 2,
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center',
          },
        };
      default:
        return {};
    }
  })();

  const { bgColor, textColor } = (() => {
    if (colors) {
      return colors;
    }
    switch (type) {
      case 'Primary':
        return {
          bgColor: `Button / ${backgroundResult} / Primary`,
          textColor: `Button / ${backgroundResult} / Primary Text`,
        };
      case 'Secondary':
        return {
          bgColor: `Button / ${backgroundResult} / Secondary`,
          textColor: `Button / ${backgroundResult} / Secondary Text`,
        };
      case 'Tertiary':
        return {
          bgColor: `Button / ${backgroundResult} / Tertiary`,
          textColor: `Button / ${backgroundResult} / Secondary Text`,
        };
      case 'Special':
        return {
          bgColor: `Link / ${backgroundResult} / Special`,
          textColor: `Label / ${backgroundResult} / Selected`,
        };
      case 'Only Text':
        return {
          bgColor: `Button / ${backgroundResult} / Only Text`,
          textColor: `Button / ${backgroundResult} / Only Text Text`,
        };
      case 'Only Text Link':
        return {
          bgColor: `Button / ${backgroundResult} / Only Text`,
          textColor: `Link / ${backgroundResult} / Special`,
        };
      case 'Light Text Link':
        return {
          bgColor: `Button / ${backgroundResult} / Only Text`,
          textColor: `Link / ${backgroundResult} / Primary`,
        };
      case 'Icon Button':
        return {
          bgColor: `Button / ${backgroundResult} / Secondary`,
          textColor: `Link / ${backgroundResult} / Primary`,
        };
      default:
        return {
          bgColor: `Button / ${backgroundResult} / ${type}`,
          textColor: `Label / ${backgroundResult} / Secondary`,
        };
    }
  })();

  const isIcon = ['Icon Button'].includes(type);

  return (
    <TouchableElement
      onPress={() => (disabled ? () => {} : onPress && onPress())}
      onPressIn={disabled ? undefined : onPressIn}
      testID={testID}
    >
      {({ boxStyle, pressHoverColor }) => (
        <View
          style={[
            boxStyle,
            {
              justifyContent: 'center',
              alignContent: 'center',
              alignItems: 'center',
              userSelect: 'none',
            },
            bgColor && {
              paddingLeft: s(paddingLeft, false),
              paddingRight: s(paddingRight, false),
              paddingTop: s(paddingTop, false),
              paddingBottom: s(paddingBottom, false),
              borderRadius: customBorderRadius ? customBorderRadius : s(borderRadius, false),
              backgroundColor: C(pressHoverColor(disabled ? `Button / ${backgroundResult} / Disabled` : bgColor), false),
            },
            minWidth && {
              minWidth: s(minWidth),
            },
            sizeConfig,
            customStyle,
          ]}
        >
          {loading && (
            <View style={{ position: 'absolute' }}>
              <ActivityIndicator size="small" color={C(pressHoverColor(disabled ? `Label / ${backgroundResult} / Quinary` : textColor), false)} />
            </View>
          )}
          {isIcon ? (
            props.children
          ) : (
            <Text
              style={[
                textFont,
                {
                  color: C(pressHoverColor(disabled ? `Label / ${backgroundResult} / Quinary` : textColor), false),
                  opacity: loading ? 0 : 1,
                },
              ]}
              numberOfLines={1}
            >
              {props.children}
            </Text>
          )}
        </View>
      )}
    </TouchableElement>
  );
};

export default ColorWrapper(Button);
